// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"15805c96","82":"1e0b68f0","267":"ccd22252","380":"bb8151b0","453":"e32c42c0","510":"d55053ff","641":"44af4cfa","701":"0e7ad47f","784":"2931edb4","836":"5ef5077a","837":"b398cee5"}[chunkId] + ".chunk.js";
};